import React from 'react';

export const LoggedOutPage: React.FC = () => {
  const handleRestart = () => {
    // Clear session and reload
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <div className="logged-out-container">
      <div className="logged-out-panel">
        <div className="logged-out-icon">
          <i className="fa-solid fa-user-slash"></i>
        </div>
        <h1>Du er blevet logget ud</h1>
        <p>Din session er udløbet på grund af inaktivitet.</p>
        <button className="btn btn-primary" onClick={handleRestart}>
          <i className="fa-solid fa-rotate-left"></i>
          Start forfra
        </button>
      </div>
    </div>
  );
};